import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'

const ApprovalRequestsSearchPage = lazy(
  () => import('../pages/approval-requests-search/ApprovalRequestsSearchPage')
)
const McpMutationApprovalRequestPage = lazy(
  () => import('../pages/mcp-mutation-approval-request/McpMutationApprovalRequestPage')
)
const SiteSetupFormAccessApprovalRequestPage = lazy(
  () =>
    import('../pages/site-setup-form-access-approval-request/SiteSetupFormAccessApprovalRequestPage')
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const approvalManagementAdminRouter = (
  <DomainRoute route="app-admin-approvals-management-library">
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-approvals-management-library-approval-requests-search"
        component={ApprovalRequestsSearchPage}
      />
      <DomainRoute
        exact
        route="app-admin-approvals-management-library-mcp-mutation-approval-request"
        component={McpMutationApprovalRequestPage as React.ComponentType<any>}
      />
      <DomainRoute
        exact
        route="app-admin-approvals-management-library-site-setup-form-access-approval-request"
        component={SiteSetupFormAccessApprovalRequestPage as React.ComponentType<any>}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
